import { createFileRoute, redirect } from "@tanstack/react-router";
import { isAuthenticated, fetchMe } from "@/lib/auth";

// Eager file: validateSearch + beforeLoad only. The signup form UI lives
// in `index.lazy.tsx` so authenticated visitors who bounce to / never
// download the form chunk. Search params let marketing CTAs prefill the
// plan picker via `/signup?plan=pro`.
export const Route = createFileRoute("/signup/")({
  validateSearch: (search: Record<string, unknown>) => {
    const out: { plan?: "free" | "starter" | "pro" | "agency" } = {};
    if (
      typeof search.plan === "string" &&
      ["free", "starter", "pro", "agency"].includes(search.plan)
    ) {
      out.plan = search.plan as "free" | "starter" | "pro" | "agency";
    }
    return out;
  },
  beforeLoad: async () => {
    if (!isAuthenticated()) return;
    const auth = await fetchMe();
    if (auth) {
      throw redirect({ to: "/" });
    }
    // Stale token — fetchMe cleared it. Fall through to the signup form.
  },
});
